<template>
  <Layout :navbar="false">
    <div class="bg-bridge py-5 flex-grow-1">
      <div class="container py-5">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-4">
            <InertiaLink
              class="h1 d-block font-weight-light font-family-serif text-center text-white mb-3"
              :href="route('home')"
            >
              <img src="/images/Clausify_Logo_White.png" class="col-4 col-md-8" />
            </InertiaLink>
            <div class="card">
              <div class="card-body p-4">
                <h4 class="mb-4">Login</h4>
                <form @submit.prevent="submit">
                  <div class="form-group">
                    <TextInput
                      v-model="form.email"
                      :errors="$page.props.errors.email"
                      label="E-Mail Address"
                      type="email"
                      autofocus
                      autocapitalize="off"
                      name="email"
                      validateSuccess
                      validateError
                    />
                  </div>

                  <div class="form-group mb-2">
                    <TextInput
                      label="Password"
                      v-model="form.password"
                      :errors="$page.props.errors.password"
                      type="password"
                      name="password"
                      validateError
                    />
                  </div>

                  <div class="form-group">
                    <InertiaLink :href="route('password.request')">
                      Forgot your password?
                    </InertiaLink>
                  </div>

                  <!--
                    <div class="form-group row">
                      <div class="col-md-6 offset-md-4">
                        <div class="form-check">
                          <input
                            id="remember"
                            v-model="form.remember"
                            class="form-check-input"
                            type="checkbox"
                          />
                          <label class="form-check-label" for="remember">Remember Me</label>
                        </div>
                      </div>
                    </div>
                  -->

                  <LoadingButton
                    :loading="sending"
                    class="btn btn-block btn-primary btn-rounded"
                    type="submit"
                  >
                    Login
                  </LoadingButton>
                </form>

                <div class="mt-3 w-75 mx-auto text-center">
                  By logging in, I accept Clausify's <a :href="route('use-terms')" target="_blank">Use Terms</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="register py-5">
      <div class="container py-5">
        <h2 class="text-center mb-3">Interested in signing up?</h2>
        <div class="row justify-content-center">
          <div class="col-4">
            <InertiaLink
              class="btn btn-primary btn-rounded btn-block"
              :href="route('register-interest.create')"
            >
              Register interest
            </InertiaLink>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';

export default {
  components: {
    Layout,
    LoadingButton,
    TextInput,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: this.$inertia.form({
        email: null,
        password: null,
        remember: null,
      }),
    };
  },
  mounted() {
    document.title = 'Login | Claus.ify';
  },
  methods: {
    submit() {
      this.sending = true;

      const route = this.route('login');

      this.form.post(route, {
        preserveScroll: true,
        onSuccess: () => {
          this.sending = false;
        },
        onError: () => {
          this.sending = false;
        },
      });
    },
  },
};
</script>
